export default __webpack_public_path__ + "static/media/Pearl Web Solutions Logo 5.fw.167c2ad4.png";